import { BlockStack, Box, InlineStack, LegacyStack, Text } from '@shopify/polaris'

import { InternalLink, queryString } from '../common/helpers'
import * as urls from '../common/urls'
import { UpgradeToAccessCard } from '../settings-page/UpgradeToAccessCard'
import { useAdvancedDashboardFilters } from './advanced-filters'
import { AdvancedDasbordFilterSelectors } from './AdvancedDasbordFilterSelectors'
import { AdvancedDashboardFilterLabels } from './AdvancedDashboardFilterLabels'
import { AverageLengthReport } from './AverageLengthReport'
import { DashboardAnalyticsStartDateInfo } from './DashboardSettingsModal'
import { RetentionCohortReport } from './RetentionCohortReport'

export const CustomerRententionAndValueStatsPlaceholder = () => {
  const advancedFilters = useAdvancedDashboardFilters()

  return (
    <BlockStack gap="400">
      <Box paddingInline={{ xs: '400', sm: '0', md: '0', lg: '0', xl: '0' }}>
        <LegacyStack alignment="baseline">
          <LegacyStack.Item fill>
            <Text variant="headingMd" as="h1">
              Customer retention and value
            </Text>
          </LegacyStack.Item>
          <LegacyStack.Item>
            <InlineStack gap="200">
              <AdvancedDasbordFilterSelectors filter={advancedFilters} disabled={true} />
            </InlineStack>
          </LegacyStack.Item>
        </LegacyStack>
      </Box>
      <UpgradeToAccessCard>
        <Text as="p">
          Unlock additional stats and filters by{' '}
          <InternalLink url={urls.pricingPlansUrl()} target={'_blank'}>
            upgrading
          </InternalLink>{' '}
          to our <Text as="strong">Traction Plan</Text> or higher.
        </Text>
      </UpgradeToAccessCard>
      <img
        style={{ width: '100%' }}
        src="/images/enhanced_reports_placeholder.png"
        alt="Customer retention and value"
      />
    </BlockStack>
  )
}

export const CustomerRetentionAndValueStats = () => {
  const advancedFilters = useAdvancedDashboardFilters()
  const filterQueryString = queryString(advancedFilters.filterParams)

  return (
    <LegacyStack vertical wrap={false}>
      <Box paddingInline={{ xs: '400', sm: '0', md: '0', lg: '0', xl: '0' }}>
        <BlockStack gap="200">
          <InlineStack align="space-between" blockAlign="center" gap="200">
            <Text variant="headingMd" as="h1">
              Customer retention and value
            </Text>
            <AdvancedDasbordFilterSelectors filter={advancedFilters} />
          </InlineStack>
          <DashboardAnalyticsStartDateInfo />
        </BlockStack>
      </Box>
      {advancedFilters.isFiltered && <AdvancedDashboardFilterLabels filter={advancedFilters} />}
      <AverageLengthReport
        filterQuery={filterQueryString}
        filterLabel={advancedFilters.isFiltered ? 'Filtered' : ''}
      />
      {/*
      <CustomerValueAndChurnReport
        filterLabel={advancedFilters.isFiltered ? 'Filtered' : ''}
        filterQuery={filterQueryString}
      />
      */}
      <RetentionCohortReport
        filterLabel={advancedFilters.isFiltered ? 'Filtered' : ''}
        filterQuery={filterQueryString}
      />
    </LegacyStack>
  )
}
